import variableColors from "@/base/global/variables/figma.colors.json";

export const skeletonThemeToken: any = {
  gradientFromColor: variableColors.ColorFigmaNeutralGrayscaleGray30,
  gradientToColor: variableColors.ColorFigmaNeutralGrayscaleGray40,
};
